(function () {
  const nav = document.getElementById('main-nav');
  if (!nav) return;
  const isHome = nav.dataset.page === 'index';

  function applyScrollState() {
    if (isHome && window.scrollY <= 60) {
      nav.className = 'transparent';
    } else {
      nav.className = 'solid';
    }
  }
  function setNavState() {
    if (nav.classList.contains('search-open')) return;
    applyScrollState();
  }
  setNavState();
  window.addEventListener('scroll', setNavState, { passive: true });

  const openBtn = nav.querySelector('[data-action="open-search"]');
  const closeBtn = nav.querySelector('.search-close');
  const input = nav.querySelector('.search-input');
  function closeSearch() {
    if (input) input.value = '';
    const results = nav.querySelector('.search-results');
    if (results) results.innerHTML = '';
    nav.dispatchEvent(new CustomEvent('jia:search-close'));
    applyScrollState();
  }
  openBtn?.addEventListener('click', () => {
    nav.className = 'search-open';
    setTimeout(() => input?.focus(), 80);
  });
  closeBtn?.addEventListener('click', closeSearch);
  input?.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });

  // v1: Favourites is a decorative no-op
  nav.querySelector('[data-favourites-noop]')?.addEventListener('click', (e) => e.preventDefault());
})();

// ── Predictive search ──
(function () {
  const input = document.querySelector('.search-input');
  if (!input) return;
  const form = input.closest('form');
  if (!form) return;
  let resultsBox = form.querySelector('.search-results');
  if (!resultsBox) {
    resultsBox = document.createElement('div');
    resultsBox.className = 'search-results';
    form.appendChild(resultsBox);
  }

  let timer = null;
  let lastQuery = '';
  const nav = document.getElementById('main-nav');
  nav?.addEventListener('jia:search-close', () => { lastQuery = ''; });
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (!q) { resultsBox.innerHTML = ''; lastQuery = ''; return; }
    if (q === lastQuery) return;
    lastQuery = q;
    timer = setTimeout(async () => {
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) { resultsBox.innerHTML = '<p class="search-empty">Search unavailable</p>'; return; }
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          resultsBox.innerHTML = '<p class="search-empty">No results</p>';
        } else {
          resultsBox.innerHTML = '';
          for (const p of products) {
            const a = document.createElement('a');
            a.className = 'search-result';
            a.href = String(p.url || '');
            a.textContent = `${p.title || ''}`;
            resultsBox.appendChild(a);
          }
        }
      } catch (err) {
        resultsBox.innerHTML = '<p class="search-empty">Network error</p>';
      }
    }, 180);
  });
})();
